const { default: styled } = require("styled-components");

export const DashboardWrapper = styled.section`
  width: 100%;
  max-width: 1060px;
  margin: 0 auto;
  padding: 8px 24px 24px;

  @media (max-width: 768px) {
    padding: 8px 12px 20px;
  }
`;

export const Footer = styled.footer`
  display: flex;
  gap: 2rem;
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  text-align: left;
  padding-bottom: 12px;
  border-bottom: 1px solid #d7d2e6;
`;

export const DetailCardsWrapper = styled.section`
  display: flex;
  padding-bottom: 20px;
  padding-top: 50px;
`;

export const DetailCard = styled.div`
  border: 1px solid #436ab2;
  padding: 20px 15px;
  border-radius: 8px;
  margin-right: 20px;
  width: 100%;
  max-width: 200px;
  background: #e7f2ff;
  height: 150px;
`;

export const InnerDiv = styled.div`
  align-items: center;
  padding-bottom: 20px;
`;

export const AccountsSection = styled.section`
  margin-top: 40px;
`;

export const AccountsTitle = styled.h3`
  margin: 0 0 14px;
  color: #261d44;
  font-family: "Inter";
  font-size: 34px;
  font-weight: 700;
  letter-spacing: 0.2px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

export const AccountsSubTitle = styled.h4`
  margin: 0px 0px 16px 0px;
  color: #231A3D;
  font-family: "Inter";
  font-size: 20px;
  font-weight: 600;
`;

export const AccountsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 760px;
`;

export const AccountRow = styled.button`
  width: 100%;
  border: 0;
  border-radius: 4px;
  padding: 10px 14px;
  background: #f6f3ff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
  height: 48px;
  &:hover {
    background: #e3deee;
    transform: translateY(-1px);
  }
`;

export const AccountName = styled.span`
  color: #4A4A4A;
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;
